<template>
    <v-btn primary @click="onSelectClicked()">
        {{ toSentenceCase($t('actions.select')) }}
    </v-btn>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    methods: {
        async onSelectClicked() {
            await this.params.onSelectClicked(this.params.data._id);
        },
    },
});
</script>
